import { render, staticRenderFns } from "./GridSkeleton.vue?vue&type=template&id=cafdd74e"
import script from "./GridSkeleton.vue?vue&type=script&lang=js"
export * from "./GridSkeleton.vue?vue&type=script&lang=js"
import style0 from "./GridSkeleton.vue?vue&type=style&index=0&id=cafdd74e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports